import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { ApiResponse, TaxRateListResponse, TaxRateVm } from '@/api/types'

function toBool(value: unknown): boolean {
  return value === true || value === 1 || value === '1' || value === 'true'
}

function normalizeTaxRate(item: any, branchId = 0): TaxRateVm {
  return {
    taxRateId: item.taxRateId ?? item.TaxRateId ?? item.id ?? item.Id ?? 0,
    taxRateNameEn:
      item.taxRateNameEn ??
      item.TaxRateNameEn ??
      item.name ??
      item.Name ??
      item.taxRateName ??
      item.TaxRateName ??
      '',
    taxRateNameAr:
      item.nameAr ??
      item.NameAr ??
      item.taxRateNameAr ??
      item.TaxRateNameAr ??
      '',
    taxPercent: Number(item.taxPercent ?? item.TaxPercent ?? item.percent ?? item.Percent ?? 0),
    isDefault: toBool(item.isDefault ?? item.IsDefault),
    goodsOrService: Number(item.goodsOrService ?? item.GoodsOrService ?? item.goodOrService ?? item.GoodOrService ?? 0),
    purchaseOrSales: Number(item.purchaseOrSales ?? item.PurchaseOrSales ?? 0),
    branchId: Number(item.branchId ?? item.BranchId ?? branchId ?? 0),
  }
}

class TaxRateService {
  async getAll(branchId: number, pageNumber: number, pageSize: number): Promise<TaxRateListResponse> {
    const url = endpoints.taxRate.getAll(branchId, pageNumber, pageSize)
    const response = await apiClient.get<ApiResponse<any> | any>(url)
    const payload = response.data
    const raw = payload && typeof payload === 'object' && 'data' in payload ? payload.data : payload

    const list: any[] = Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : []

    return {
      totalRecords: Number(raw?.totalRecords ?? payload?.totalRecords ?? list.length ?? 0),
      pageNumber: Number(raw?.pageNumber ?? payload?.pageNumber ?? pageNumber),
      pageSize: Number(raw?.pageSize ?? payload?.pageSize ?? pageSize),
      data: list.map((x) => normalizeTaxRate(x, branchId)),
    }
  }

  async getById(id: number, branchId: number): Promise<TaxRateVm | null> {
    const url = endpoints.taxRate.getById(id, branchId)
    const response = await apiClient.get<ApiResponse<any> | any>(url)
    const payload = response.data
    const raw = payload && typeof payload === 'object' && 'data' in payload ? payload.data : payload
    if (!raw || typeof raw !== 'object') return null
    return normalizeTaxRate(raw, branchId)
  }

  async save(data: TaxRateVm): Promise<any> {
    const response = await apiClient.post(endpoints.taxRate.save, data)
    return response.data
  }

  async update(data: TaxRateVm): Promise<any> {
    const response = await apiClient.put(endpoints.taxRate.update, data)
    return response.data
  }

  async delete(id: number): Promise<any> {
    const response = await apiClient.delete(endpoints.taxRate.delete(id))
    return response.data
  }
}

export const taxRateService = new TaxRateService()
